import React, { useState } from "react";
import FormatDateTime from "../../utils/formatDateTime";
import { ChevronsUpDownIcon, RefreshCcwIcon, FilterIcon } from "lucide-react";
import { MoveRightIcon, MoveLeftIcon } from "lucide-react";
import { handleSortLivePositionsData } from "../../utils/sortFunctions";

import Modal from "../../components/modal";
import apiClient from "../../utils/apiClient";
import toast from "react-hot-toast";
import ExitPositionModal from "./Modals/ExitPositionModal";
import TPModal from "./Modals/TPModal";
import DriftModal from "./Modals/DriftModal";
import server from "../../utils/serverConfig";

const LivePositionsCM = ({
  filteredLivePositionsData,
  setFilteredLivePositionsFno,
  setFilteredLivePositionsEquity,
  sortOrder,
  setSortOrder,
  currentState,
  allUser,
  currentPage,
  setCurrentPage,
}) => {
  let itemsPerPage = 20;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredLivePositionsData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const totalPages = Math.ceil(filteredLivePositionsData.length / itemsPerPage);

  // console.log("filteredLivePositionsData",filteredLivePositionsData);
  // console.log("totalPages",totalPages);

  const displayPageNumbers = () => {
    const pageNumbers = [];
    const maxPageButtons = 5; // You can adjust this value based on your preference

    let startPage;
    let endPage;

    if (totalPages <= maxPageButtons) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= Math.ceil(maxPageButtons / 2)) {
        startPage = 1;
        endPage = maxPageButtons;
      } else if (currentPage + Math.floor(maxPageButtons / 2) >= totalPages) {
        startPage = totalPages - maxPageButtons + 1;
        endPage = totalPages;
      } else {
        startPage = currentPage - Math.floor(maxPageButtons / 2);
        endPage = currentPage + Math.floor(maxPageButtons / 2);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          className={`flex items-center justify-center text-xs  font-semibold rounded-full h-5 w-5 ${
            currentPage === i
              ? "bg-[#07F2C7] text-black"
              : "bg-white/10 text-white/40"
          }`}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </button>
      );
    }

    return pageNumbers;
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const [showDriftModal, setShowDriftModal] = useState(false);
  const [showTPModal, setShowTPModal] = useState(false);
  const [showExitModal, setShowExitModal] = useState(false);

  const [currentPositionData, setCurrentPositionData] = useState(null);

  const handleCloseDriftModal = () => {
    setShowDriftModal(false);
  };

  const handleOpenDriftModal = (position) => {
    setCurrentPositionData(position);
    setShowDriftModal(true);
  };

  const handleCloseTPModal = () => {
    setShowTPModal(false);
  };

  const handleOpenTPModal = (position) => {
    setCurrentPositionData(position);
    setShowTPModal(true);
  };

  const handleCloseExitModal = () => {
    setShowExitModal(false);
  };

  const handleOpenExitModal = (position) => {
    setCurrentPositionData(position);
    setShowExitModal(true);
  };

  const handlePositionDrift = () => {
    if (currentPositionData !== null) {
      console.log("Drift Position", currentPositionData);

      let config = {
        method: "post",
        url: `${server.godseye.baseUrl}drift_positions`,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(currentPositionData),
      };

      apiClient
        .request(config)
        .then((response) => {
          console.log("Drift Position response:", response.data);

          if (response.data.status === 200) {
            toast.success("Position Drifted Successful !!", {
              duration: 5000,
            });
          } else {
            toast.error("Position Drift Failed !!", {
              duration: 5000,
            });
          }
          handleCloseDriftModal();
        })
        .catch((error) => {
          console.log("Error in position request:", error);
          handleCloseDriftModal();
        });
    } else {
      alert("Please select a position for Drift");
    }
  };

  const handlePositionTP = () => {
    if (currentPositionData !== null) {
      console.log("TP Position", currentPositionData);

      let config = {
        method: "post",
        url: `${server.godseye.baseUrl}tp_positions`,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(currentPositionData),
      };

      apiClient
        .request(config)
        .then((response) => {
          console.log("TP Position response:", response.data);

          if (response.data.status === 200) {
            toast.success("Position TP Successful !!", {
              duration: 5000,
            });
          } else {
            toast.error("Position TP Failed !!", {
              duration: 5000,
            });
          }
          handleCloseTPModal();
        })
        .catch((error) => {
          console.log("Error in position request:", error);
          handleCloseTPModal();
        });
    } else {
      alert("Please select a position for TP");
    }
  };

  const handleExitPosition = () => {
    if (currentPositionData !== null) {
      console.log("EXIT Position", currentPositionData);

      let config = {
        method: "post",
        url: `${server.godseye.baseUrl}exit_positions`,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(currentPositionData),
      };

      apiClient
        .request(config)
        .then((response) => {
          console.log("Exit Position response:", response.data);

          if (response.data.status === 200) {
            toast.success("Position Exit Successful !!", {
              duration: 5000,
            });
          } else {
            toast.error("Position Exit Failed !!", {
              duration: 5000,
            });
          }
          handleCloseExitModal();
        })
        .catch((error) => {
          console.log("Error in exit position request:", error);
          handleCloseExitModal();
        });
    } else {
      alert("Please select a position for exit");
    }
  };

  return (
    <>
      {filteredLivePositionsData && filteredLivePositionsData?.length === 0 ? (
        <div className="w-full h-full flex flex-col items-center justify-center text-white">
          No Live Position Found!!
        </div>
      ) : (
        <>
          <div className="z-0 w-full h-[calc(100vh-160px)] custom-scroll overflow-x-auto  shadow-md animate-reveal transition-all duration-500 ease-in">
            {/* <div className="bg-black   text-sm w-full relative z-0 ">
              <div className=" text-sm text-left ">
                <div className="flex flex-row bg-black text-white border-b  border-white ">
                  <div className="w-[20%] px-4 py-6">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortLivePositionsData(
                          filteredLivePositionsData,
                          setFilteredLivePositionsFno,
                          setFilteredLivePositionsEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "symbol"
                        )
                      }
                    >
                      Symbol
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </div>
                  <div className="w-[8%] px-4 py-6">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortLivePositionsData(
                          filteredLivePositionsData,
                          setFilteredLivePositionsFno,
                          setFilteredLivePositionsEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "side"
                        )
                      }
                    >
                      Buy/Sell
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </div>
                  <div className="w-[10%] px-4 py-6">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortLivePositionsData(
                          filteredLivePositionsData,
                          setFilteredLivePositionsFno,
                          setFilteredLivePositionsEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "netQty"
                        )
                      }
                    >
                      Net Qty
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </div>

                  <div className="w-[10%] px-4 py-6">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortLivePositionsData(
                          filteredLivePositionsData,
                          setFilteredLivePositionsFno,
                          setFilteredLivePositionsEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "netAvg"
                        )
                      }
                    >
                      Avg Price
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </div>
                  <div className="w-[10%] px-4 py-6">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortLivePositionsData(
                          filteredLivePositionsData,
                          setFilteredLivePositionsFno,
                          setFilteredLivePositionsEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "ltp"
                        )
                      }
                    >
                      LTP
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </div>
                  <div className="w-[10%] px-4 py-6">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortLivePositionsData(
                          filteredLivePositionsData,
                          setFilteredLivePositionsFno,
                          setFilteredLivePositionsEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "realized_profit"
                        )
                      }
                    >
                      Realized P&L
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </div>
                  <div className="w-[10%] px-4 py-6">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortLivePositionsData(
                          filteredLivePositionsData,
                          setFilteredLivePositionsFno,
                          setFilteredLivePositionsEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "unrealized_profit"
                        )
                      }
                    >
                      Unrealized P&L
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </div>
                  <div className="w-[10%] px-4 py-6">
                    <span
                      className="flex items-center cursor-pointer"
                      onClick={() =>
                        handleSortLivePositionsData(
                          filteredLivePositionsData,
                          setFilteredLivePositionsFno,
                          setFilteredLivePositionsEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "pl"
                        )
                      }
                    >
                      Total P&L
                      <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                    </span>
                  </div>
                  <div className="w-[11%] px-4 py-6">
                    <span
                      className="flex items-center cursor-pointer"
                      
                    >
                      Actions
                      
                    </span>
                  </div>
                </div>
              </div>
              <div className="">
                {filteredLivePositionsData &&
                  currentItems?.map((item, index) => {
                    const clientIdsToMark = item.clientIds;
                    return (
                      <div key={index} className="border-b border-white">
                        <div className="flex flex-row bg-black z-0  font-medium text-white hover:bg-black/90">
                          <div className="w-[20%] px-4 py-4  border-r border-white-500">
                            {item.symbol.replace("NSE:", "")}
                          </div>

                          <div
                            className={`w-[8%] px-4 py-4  border-r border-white-500 ${
                              item.side === 1
                                ? "text-emerald-600"
                                : item.side === -1
                                ? "text-rose-500"
                                : "text-blue-500"
                            }`}
                          >
                            {item.side === 1 ? "BUY" : "SELL"}
                          </div>

                          <div className="w-[10%] px-4 py-4  border-r border-white-500">
                            {item.netQty}
                          </div>
                          <div className="w-[10%] px-4 py-4  border-r border-white-500">
                            {item.netAvg.toFixed(2)}
                          </div>
                          <div className="w-[10%] px-4 py-4  border-r border-white-500">
                            
                            {item.ltp.toFixed(2)}
                          </div>
                          <div
                            className={`w-[10%] px-4 py-4  border-r border-white-500 
                            ${
                              item.realized_profit.toFixed(2) > 0
                                ? "text-emerald-600"
                                : item.realized_profit.toFixed(2) < 0
                                ? "text-rose-500"
                                : "text-white"
                            }
                            `}
                          >
                            {item.realized_profit.toFixed(2)}
                          </div>
                          <div
                            className={`w-[10%] px-4 py-4  border-r border-white-500 
                            ${
                              item.unrealized_profit.toFixed(2) > 0
                                ? "text-emerald-600"
                                : item.unrealized_profit.toFixed(2) < 0
                                ? "text-rose-500"
                                : "text-white"
                            }
                            `}
                          >
                            
                            {item.unrealized_profit?.toFixed(2)}
                          </div>
                          <div
                            className={`w-[10%] px-4 py-4 border-r border-white-500   ${
                              item.pl.toFixed(2) > 0
                                ? "text-emerald-600"
                                : item.pl.toFixed(2) < 0
                                ? "text-rose-500"
                                : "text-white"
                            }`}
                          >
                            
                            {(
                              item?.unrealized_profit + item?.realized_profit
                            )?.toFixed(2)}
                          </div>

                          <div className="flex items-center justify-center">
                            action

                          </div>
                        </div>

                        
                      </div>
                    );
                  })}
              </div>
            </div> */}

            <div className="bg-black text-sm w-full relative z-0">
              <table className="w-full text-left text-white border-collapse border-none border-white">
                <thead>
                  <tr className="bg-black border-b border-white">
                    <th
                      className="px-4 py-6 cursor-pointer"
                      onClick={() =>
                        handleSortLivePositionsData(
                          filteredLivePositionsData,
                          setFilteredLivePositionsFno,
                          setFilteredLivePositionsEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "symbol"
                        )
                      }
                    >
                      <div className="flex items-center justify-start">
                        Symbol{" "}
                        <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                      </div>
                    </th>
                    <th
                      className="px-4 py-6 cursor-pointer"
                      onClick={() =>
                        handleSortLivePositionsData(
                          filteredLivePositionsData,
                          setFilteredLivePositionsFno,
                          setFilteredLivePositionsEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "side"
                        )
                      }
                    >
                      <div className="flex items-center justify-center">
                        Buy/Sell{" "}
                        <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                      </div>
                    </th>
                    <th
                      className="px-4 py-6 cursor-pointer"
                      onClick={() =>
                        handleSortLivePositionsData(
                          filteredLivePositionsData,
                          setFilteredLivePositionsFno,
                          setFilteredLivePositionsEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "netQty"
                        )
                      }
                    >
                      <div className="flex items-center justify-center">
                        Net Qty{" "}
                        <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                      </div>
                    </th>
                    <th
                      className="px-4 py-6 cursor-pointer"
                      onClick={() =>
                        handleSortLivePositionsData(
                          filteredLivePositionsData,
                          setFilteredLivePositionsFno,
                          setFilteredLivePositionsEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "netAvg"
                        )
                      }
                    >
                      <div className="flex items-center justify-center">
                        Avg Price{" "}
                        <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                      </div>
                    </th>
                    <th
                      className="px-4 py-6 cursor-pointer"
                      onClick={() =>
                        handleSortLivePositionsData(
                          filteredLivePositionsData,
                          setFilteredLivePositionsFno,
                          setFilteredLivePositionsEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "ltp"
                        )
                      }
                    >
                      <div className="flex items-center justify-center">
                        LTP{" "}
                        <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                      </div>
                    </th>
                    <th
                      className="px-4 py-6 cursor-pointer"
                      onClick={() =>
                        handleSortLivePositionsData(
                          filteredLivePositionsData,
                          setFilteredLivePositionsFno,
                          setFilteredLivePositionsEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "strategy"
                        )
                      }
                    >
                      <div className="flex items-center justify-center">
                        Strategy
                        <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                      </div>
                    </th>
                    {/* <th
                      className="px-4 py-6 cursor-pointer"
                      onClick={() =>
                        handleSortLivePositionsData(
                          filteredLivePositionsData,
                          setFilteredLivePositionsFno,
                          setFilteredLivePositionsEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "unrealized_profit"
                        )
                      }
                    >
                      <div className="flex items-center justify-center">
                        Unrealized P&L{" "}
                        <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                      </div>
                    </th> */}
                    <th
                      className="px-4 py-6 cursor-pointer"
                      onClick={() =>
                        handleSortLivePositionsData(
                          filteredLivePositionsData,
                          setFilteredLivePositionsFno,
                          setFilteredLivePositionsEquity,
                          setSortOrder,
                          sortOrder,
                          currentState,
                          "pl"
                        )
                      }
                    >
                      <div className="flex items-center justify-center">
                        Total P&L{" "}
                        <ChevronsUpDownIcon className="h-4 w-4 text-white ml-2" />
                      </div>
                    </th>
                    <th className="px-4 py-6 min-w-[120px] text-center">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredLivePositionsData &&
                    currentItems?.map((item, index) => (
                      <tr
                        key={index}
                        className="border-b border-white font-medium hover:bg-black/90"
                      >
                        <td className="px-4 py-4 border-r border-white-500">
                          {item.symbol.replace("NSE:", "")}
                        </td>
                        <td
                          className={`px-4 py-4 border-r border-white-500 ${
                            item.side === 1
                              ? "text-emerald-600"
                              : "text-rose-500"
                          }`}
                        >
                          {item.side === 1 ? "BUY" : "SELL"}
                        </td>
                        <td className="px-4 py-4 border-r border-white-500 text-right">
                          {item.netQty}
                        </td>
                        <td className="px-4 py-4 border-r border-white-500 text-right">
                          {item.netAvg.toFixed(2)}
                        </td>
                        <td className="px-4 py-4 border-r border-white-500 text-right">
                          {item?.ltp !== 'N/A' && item?.ltp.toFixed(2)}
                        </td>
                        <td
                          className={`px-4 py-4 border-r border-white-500 text-right `}
                        >
                          {item.strategy}
                        </td>
                        {/* <td
                          className={`px-4 py-4 border-r border-white-500 text-right ${
                            item.unrealized_profit > 0
                              ? "text-emerald-600"
                              : "text-rose-500"
                          }`}
                        >
                          {item.unrealized_profit?.toFixed(2)}
                        </td> */}
                        <td
                          className={`px-4 py-4 border-r border-white-500 text-right ${
                            parseFloat(item.pl) > 0 ? "text-emerald-600" : "text-rose-500"
                          }`}
                        >
                          {(
                            item.pl
                          ).toFixed(2)}
                        </td>
                        <td className="px-1 py-2 text-center">
                          <div className="flex items-center justify-center  space-x-4">
                            <div
                              onClick={() => handleOpenDriftModal(item)}
                              className="bg-violet-800 cursor-pointer hover:bg-violet-500 text-white font-semibold rounded-[4px] px-2 py-[2px] text-sm"
                            >
                              Drift
                            </div>
                            <div
                              onClick={() => handleOpenTPModal(item)}
                              className="bg-amber-800 cursor-pointer hover:bg-amber-500 text-white font-semibold rounded-[4px] px-2 py-[2px] text-sm"
                            >
                              TP
                            </div>
                            <div
                              onClick={() => handleOpenExitModal(item)}
                              className="bg-rose-800 cursor-pointer hover:bg-rose-500 text-white font-semibold rounded-[4px] px-2 py-[2px] text-sm"
                            >
                              Exit
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="flex  mt-4 items-center justify-end  px-10 ">
            <div className="flex items-center  space-x-6 justify-end w-full">
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className=" group disabled:text-white/30  disabled:cursor-not-allowed tracking-widest flex items-center justify-center px-2 py-1  text-sm font-medium text-white rounded-sm "
              >
                <MoveLeftIcon className="h-4 w-4 text-white group-disabled:text-white/30  mr-2" />
                Prev
              </button>

              <div className="flex space-x-4 items-center justify-center ">
                {displayPageNumbers()}
              </div>

              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="group disabled:text-white/30 disabled:cursor-not-allowed tracking-widest flex items-center justify-center px-2 py-1  text-sm font-medium text-white rounded-sm "
              >
                Next
                <MoveRightIcon className="h-4 w-4 text-white group-disabled:text-white/30  ml-2" />
              </button>
            </div>
          </div>
        </>
      )}

      {showDriftModal && (
        <DriftModal
          currentPositionData={currentPositionData && currentPositionData}
          handleCloseDriftModal={handleCloseDriftModal}
          handlePositionDrift={handlePositionDrift}
        />
      )}

      {showTPModal && (
        <TPModal
          currentPositionData={currentPositionData && currentPositionData}
          handleCloseTPModal={handleCloseTPModal}
          handlePositionTP={handlePositionTP}
        />
      )}

      {showExitModal && (
        <ExitPositionModal
          currentPositionData={currentPositionData && currentPositionData}
          handleCloseExitModal={handleCloseExitModal}
          handleExitPosition={handleExitPosition}
        />
      )}
    </>
  );
};

export default LivePositionsCM;
